module.exports = __webpack_public_path__ + "img/1.e44575fe.jpg";